(() => {
    const SELECTOR = '[data-section-type="video-carousel"]';
    const STATE_KEY = 'videoCarouselBootstrap';

    function hasVideoCarousel(root = document) {
        return Boolean(root.querySelector(SELECTOR));
    }

    function loadScript(src) {
        return new Promise((resolve, reject) => {
            const existing = document.querySelector(`script[src="${src}"]`);
            if (existing) {
                if (existing.dataset.loaded === 'true') {
                    resolve();
                    return;
                }

                existing.addEventListener('load', () => resolve(), { once: true });
                existing.addEventListener('error', () => reject(new Error(`Failed to load script: ${src}`)), { once: true });
                return;
            }

            const script = document.createElement('script');
            script.src = src;
            script.defer = true;
            script.dataset.loaded = 'false';
            script.addEventListener('load', () => {
                script.dataset.loaded = 'true';
                resolve();
            }, { once: true });
            script.addEventListener('error', () => reject(new Error(`Failed to load script: ${src}`)), { once: true });
            document.head.appendChild(script);
        });
    }

    async function initIfNeeded(root = document) {
        if (!hasVideoCarousel(root)) return;

        const src = window.__VIDEO_CAROUSEL_SRC;
        if (!src) {
            console.warn('[Video carousel] Missing controller asset URL.');
            return;
        }

        const state = window[STATE_KEY] || (window[STATE_KEY] = {});
        state.loadingPromise = state.loadingPromise || loadScript(src);

        try {
            await state.loadingPromise;
            window.VideoCarousel?.initAll?.(root);
        } catch (err) {
            console.warn('[Video carousel] Bootstrap failed.', err);
        }
    }

    window.VideoCarouselBootstrap = {
        initIfNeeded,
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => initIfNeeded(document), { once: true });
    } else {
        initIfNeeded(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
        initIfNeeded(event.target || document);
    });
})();
